// OBT F3-C — Kapsam-geneli özet: kampanyalar tek sayfada (≤200) çekilir,
// durum/oran istemcide türetilir. Backend org-geneli özet ucu VERMEZ; bu yüzden
// yükleme SINIRI (200) şeffaftır (has_more ise ekran "kısmi" olduğunu belirtir).
import { useCallback, useEffect, useRef, useState } from 'react';
import { fetchCampaignPage } from '../reportApi';
import { normalizeObtError } from '../../obtErrors';

const SAMPLE_LIMIT = 200;

function isCanceled(error) {
  return (
    error?.code === 'ERR_CANCELED' ||
    error?.name === 'CanceledError' ||
    error?.name === 'AbortError'
  );
}

export function useOrgOverview({ enabled = true } = {}) {
  const [state, setState] = useState({
    loading: enabled, error: null, items: [], total: 0, hasMore: false, sampleLimit: SAMPLE_LIMIT,
  });
  const abortRef = useRef(null);

  const load = useCallback(async () => {
    if (!enabled) {
      setState({ loading: false, error: null, items: [], total: 0, hasMore: false, sampleLimit: SAMPLE_LIMIT });
      return;
    }
    abortRef.current?.abort();
    const controller = new AbortController();
    abortRef.current = controller;
    setState((prev) => ({ ...prev, loading: true, error: null }));
    try {
      const data = await fetchCampaignPage({ limit: SAMPLE_LIMIT, offset: 0 }, { signal: controller.signal });
      if (controller.signal.aborted) return;
      setState({
        loading: false,
        error: null,
        items: Array.isArray(data?.items) ? data.items : [],
        total: data?.page?.total ?? (data?.items?.length || 0),
        hasMore: Boolean(data?.page?.has_more),
        sampleLimit: SAMPLE_LIMIT,
      });
    } catch (error) {
      if (isCanceled(error) || controller.signal.aborted) return;
      setState({ loading: false, error: normalizeObtError(error), items: [], total: 0, hasMore: false, sampleLimit: SAMPLE_LIMIT });
    }
  }, [enabled]);

  useEffect(() => {
    load();
    return () => abortRef.current?.abort();
  }, [load]);

  return { ...state, reload: load };
}
